import React from 'react';
import { Box, CircularProgress, Typography, Paper } from '@mui/material';
import { motion } from 'framer-motion';

interface AuthLoadingProps {
  message?: string;
}

const AuthLoading: React.FC<AuthLoadingProps> = ({ message = 'Authenticating...' }) => {
  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'linear-gradient(135deg, #2b3e7d 0%, #33344a 100%)',
      }}
    >
      <motion.div
        initial={{ opacity: 0, scale: 0.9 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.3 }}
      >
        <Paper
          sx={{
            p: 6,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: 3,
            minWidth: 320,
            background: 'rgba(255, 255, 255, 0.95)',
            backdropFilter: 'blur(10px)',
          }}
        >
          <img src="/logo192.png" alt="IT Control Panel" style={{ width: 80, height: 80 }} />
          
          <Typography variant="h5" fontWeight={600} color="primary">
            IT Control Panel
          </Typography>
          
          <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2 }}>
            <CircularProgress size={40} thickness={4} />
            
            <Typography variant="body1" color="text.secondary">
              {message}
            </Typography>
          </Box>
          
          <Typography variant="caption" color="text.secondary" sx={{ mt: 2 }}>
            Connecting to Microsoft 365...
          </Typography>
        </Paper>
      </motion.div>
    </Box>
  );
};

export default AuthLoading;